// src/App.js
// FINAL VERSION – With AuthProvider & RouteGuards + Password Reset

import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Pages & Components
import Login from './pages/Login';
import ClientDashboard from './components/ClientDashboard';
import AdminDashboard from './pages/admin/AdminDashboard';
import AuthRedirect from './pages/AuthRedirect';
import QuestionnaireAccessPage from './pages/QuestionnaireAccessPage';
import PasswordResetPage from './pages/PasswordResetPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import UserAgreementPage from './pages/UserAgreementPage';
import FirmPortal from './pages/FirmPortal'; 
import VerifyEmailPage from './pages/VerifyEmailPage'; // <--- NEW IMPORT
import AuthActionPage from './pages/AuthActionPage';
import SignupSuccess from './pages/SignupSuccess';

// Route Guards (separate file)
import { PrivateRoute, PublicRoute, OrgAdminRoute } from './components/RouteGuards';

import IdleTimeout from './components/IdleTimeout';


function App() {
    return (
        <Router>
            <AuthProvider>
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                    limit={3}
                />
                <IdleTimeout /> 
                <Suspense
                    fallback={
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                            <CircularProgress />
                        </Box>
                    }
                >
                    <Routes>
                        <Route path="/" element={<AuthRedirect />} />
                        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
                        <Route path="/forgot-password" element={<PublicRoute><ForgotPasswordPage /></PublicRoute>} />
                        <Route path="/reset-password" element={<PublicRoute><PasswordResetPage /></PublicRoute>} />
                        <Route path="/verify-email" element={<VerifyEmailPage />} /> {/* <--- NEW ROUTE */}
                        <Route path="/auth-action" element={<AuthActionPage />} />
                        <Route path="/client-dashboard" element={<PrivateRoute><ClientDashboard /></PrivateRoute>} />
                        <Route path="/client-dashboard/:tab" element={<PrivateRoute><ClientDashboard /></PrivateRoute>} />
                        <Route path="/admin" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
                        <Route path="/firm-portal" element={<OrgAdminRoute><FirmPortal /></OrgAdminRoute>} />
                        <Route path="/questionnaire-access/:token" element={<QuestionnaireAccessPage />} />
                        <Route path="/user-agreement" element={<UserAgreementPage />} />
                        <Route path="/signup-success" element={<SignupSuccess />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </Suspense>
            </AuthProvider>
        </Router>
    );
}

export default App;